import { MathUtils, Vector2, Vector3 } from 'three';
import { Gesture } from '@use-gesture/vanilla';

import { appMixin } from '../utils/appMixin';
import { STORE_KEYS } from '../utils/constants';
import { CAMERA } from '../utils/config';

const _tmp = new Vector3();
export class Controls extends appMixin() {
  constructor(app, camera, object, $element) {
    super(app);
    this.camera = camera;
    this.object = object;
    this.$element = $element;

    this.$element.oncontextmenu = () => false;
    this.$element.addEventListener('scroll', this.prevent);
    this.$element.addEventListener('wheel', this.prevent);

    this.speed = 0;

    this.$element.style.touchAction = 'none';

    this.rotation = CAMERA.position.clone();
    this.lerpedRotation = this.rotation.clone();

    this.position = CAMERA.position.clone();
    this.lerpedPosition = this.position.clone();

    this.parallax = new Vector2(0, 0);
    this.lerpedParallax = new Vector2(0, 0);

    this.coolEffectPosition = new Vector3(0.2, 0.5, 2);
  }

  onAttach() {
    this.app.core.store.watch(STORE_KEYS.KONG_ROTATION, this.setRotation);
    this.app.core.store.watch(STORE_KEYS.CAMERA_ZOOM, this.setZoom);
    this.setRotation();
    this.setZoom();

    this.gesture = new Gesture(
      this.$element,
      {
        onDrag: (state) => this.updatePosition(state),
        onMove: (state) => this.updateParallax(state),
        onWheel: (state) => this.updateZoom(state),
      },
      {
        drag: {
          pointer: { buttons: [1, 2] },
          capture: true,
        },
      }
    );
  }

  updatePosition = ({ delta: [x, y], buttons }) => {
    if (this.app.core.store.get(STORE_KEYS.CONTROLS_DISABLED)) return;
    if (buttons === 1) {
      this.rotation.x += x * 0.005;
      this.rotation.y = MathUtils.clamp(this.rotation.y + y * 0.005, 0, Math.PI * 0.4);
    } else if (buttons === 2) {
      if (this.app.core.store.get(STORE_KEYS.PAN_DISABLED)) return;
      this.position.y = MathUtils.clamp(this.position.y + y * 0.002, -0.6, 1);
    }
  };

  updateZoom = ({ delta: [, y] }, force = false) => {
    if (
      (!force && this.app.core.store.get(STORE_KEYS.CONTROLS_DISABLED)) ||
      this.app.core.store.get(STORE_KEYS.ZOOM_DISABLED)
    )
      return;
    this.rotation.z = MathUtils.clamp(this.rotation.z + y * 0.005, 2, 8);
  };

  setZoom = () => {
    this.lerpedRotation.z = this.rotation.z = MathUtils.clamp(
      CAMERA.position.z - this.app.core.store.get(STORE_KEYS.CAMERA_ZOOM),
      2,
      8
    );
  };

  setRotation = () => {
    this.lerpedRotation.x = this.rotation.x = this.app.core.store.get(STORE_KEYS.KONG_ROTATION);
  };

  updateParallax = ({ xy: [x, y] }) => {
    if (this.app.core.store.get(STORE_KEYS.PARALLAX_DISABLED)) return;
    this.parallax.set(
      ((x / this.app.viewport.width) * 2 - 1) * 0.1,
      (-(y / this.app.viewport.height) * 2 + 1) * 0.1
    );
  };

  prevent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  onTick = ({ dt }) => {
    _tmp.copy(this.app.core.store.get(STORE_KEYS.CAMERA_POSITION));
    this.speed =
      this.lerpedRotation.distanceTo(this.rotation) + this.lerpedPosition.distanceTo(this.position);
    this.lerpedRotation.lerp(this.rotation, 0.01 * dt);
    this.lerpedPosition.lerp(this.position, 0.01 * dt);
    this.lerpedParallax.lerp(this.parallax, 0.01 * dt);

    this.object.rotation.y = this.lerpedRotation.x;

    this.camera.position.y =
      Math.sin(this.lerpedRotation.y) * this.lerpedRotation.z +
      this.lerpedParallax.y +
      this.lerpedPosition.y +
      _tmp.y;
    this.camera.position.z = Math.cos(this.lerpedRotation.y) * this.lerpedRotation.z + _tmp.z;
    this.camera.position.x = this.lerpedParallax.x + _tmp.x;

    this.camera.position.lerpVectors(
      this.camera.position,
      this.coolEffectPosition,
      this.app.coolEffectIntensity.value
    );

    this.camera.lookAt(
      _tmp.x,
      _tmp.y +
        this.lerpedPosition.y * (1 - this.app.coolEffectIntensity.value) +
        this.app.coolEffectIntensity.value * 0.3,
      _tmp.z
    );
    // console.log(this.lerpedRotation);
  };
}
